jQuery(function ($) {
    $(document).ready(function () {
        $(window).scroll(function () {
            if ($(window).scrollTop() > 50){
                $('#myHeader').addClass("sticky");
                $('.h_logo').addClass("show").removeClass("none");
                $('.home').addClass("none").removeClass("show");
            } else {
                $('.h_logo').addClass("none").removeClass("show");
                $('.home').addClass("show").removeClass("none");
                $('#myHeader').removeClass("sticky");
            }
        });
    });
});
